'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autoComplete = require('antd/lib/auto-complete');

var _autoComplete2 = _interopRequireDefault(_autoComplete);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Search搜索组件
 */
var Search = exports.Search = (_temp = _class = function (_React$PureComponent) {
  _inherits(Search, _React$PureComponent);

  // 把数据存入dataSource使组件可以通过ref拿到原始数据；
  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this.handleSearch = function (value, params) {
      params = params || _this.props.params;
      var select = Object.assign({}, _this.state.select, { value: value });
      if (!_this.props.noSearch && _this.props.getResolver) {
        _this.getOptions(_this.props.getResolver(value, params));
      } else {
        _this.setState({ select: select });
      }
    };

    _this.state = {
      dataSource: props.dataSource,
      select: {
        value: props.defaultValue,
        dataSource: props.options ? props.options : props.dataSource.map(function (item) {
          return _react2.default.createElement(
            _autoComplete2.default.Option,
            { key: item[props.rowKey] },
            _this.renderOption(item)
          );
        })
      }
    };
    if (props.getResolver) {
      _this.getOptions(props.getResolver(null, _this.props.params), props.defaultValue);
    }
    return _this;
  }

  _createClass(Search, [{
    key: 'find',
    value: function find(condition) {
      return this.state.dataSource.find(condition);
    }
  }, {
    key: 'renderOption',
    value: function renderOption(item) {
      var _props = this.props,
          labelKey = _props.labelKey,
          renderItem = _props.renderItem;

      if (renderItem) {
        return renderItem(item);
      } else {
        return item[labelKey];
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions(resolver, value) {
      var _this2 = this;

      var rowKey = this.props.rowKey;

      return resolver.then(function (ret) {
        var nextState = {
          dataSource: ret.dataSource,
          select: Object.assign({}, ret, {
            dataSource: ret.dataSource.map(function (item) {
              return _react2.default.createElement(
                _autoComplete2.default.Option,
                { key: item[rowKey] },
                _this2.renderOption(item)
              );
            })
          })
        };
        if (value) {
          nextState.select.value = value;
        }
        _this2.setState(nextState);
      });
    }
    /**
     * @param {string} value-输入框的内容
     * @param {} params
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var style = this.props.style || {};
      var _onSelect = this.props.onSelect;
      var InputSearch = this.props.noSearch ? null : _react2.default.createElement(_input2.default, { suffix: _react2.default.createElement(_icon2.default, { type: 'search' }) });
      style.width = style.width || 240;
      style.height = style.height || 32;
      return _react2.default.createElement(
        _autoComplete2.default,
        _extends({
          style: style,
          allowClear: true
        }, this.props, this.state.select, {
          filterOption: function filterOption(inputValue, option) {
            return inputValue === option.key || option.props.children.indexOf(inputValue) > -1;
          },
          onSearch: function onSearch(v) {
            var delay = _this3.props.delay;
            if (delay) {
              clearTimeout(_this3.timer);
              _this3.timer = setTimeout(function () {
                _this3.handleSearch(v);
              }, delay);
            } else {
              _this3.handleSearch(v);
            }
          },
          onSelect: function onSelect(v, o) {
            _onSelect && _onSelect(v, o);
            var select = Object.assign({}, _this3.state.select, { value: v });
            _this3.setState({ select: select });
          }
        }),
        InputSearch
      );
    }
  }]);

  return Search;
}(_react2.default.PureComponent), _class.propTypes = {
  getResolver: _propTypes2.default.func,
  defaultValue: _propTypes2.default.string,
  dataSource: _propTypes2.default.array,
  options: _propTypes2.default.array,
  rowKey: _propTypes2.default.string,
  renderItem: _propTypes2.default.func,
  labelKey: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  mode: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  noSearch: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  delay: _propTypes2.default.number,
  params: _propTypes2.default.object
}, _class.defaultProps = {
  rowKey: 'id',
  labelKey: 'value',
  dataSource: [] }, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/search/index.jsx
// module id = 97
// module chunks = 0